export { default as useSessionStorage } from './useSessionStorage';
export * from './useSessionStorage';
//# sourceMappingURL=index.js.map